import { client } from "@/api/client";
import interceptors from "@/api/interceptor";
// import qs from "qs";

client.interceptors.request.use(interceptors.noAuth, interceptors.onError);

function getProductReview(params) {
	return client.get("product-review/data", {
		params: params,
	});
}

export default {
	getProductReview,
};